import { callAPI } from '../../network/networkConnection';

const getActiveWarehouses = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + 'admin/warehouses/active',
      'GET',
      { 'Content-Type': 'application/json' },
      null
    )
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const warehouseService = {
  getActiveWarehouses,
};

export default warehouseService;
